import { openPickPointLink } from 'sections/PromoSection/pages/PromoPage/data'
import { scrollToId } from 'utils/helpers/scrollToId'
import { docs } from 'shared/constants/docs'

import { IComparePPData, LabelKeys } from './types'

import brandPreview from 'assets/img/promo-page/brand-pp-preview.png'
import villagePreview from 'assets/img/promo-page/village-pp-preview.png'

export const labels: Record<LabelKeys, string> = {
  location: 'Где действуют',
  placement: 'Расположение пункта',
  area: 'Помещение',
  renovation: 'Ремонт',
  branding: 'Брендирование',
  deposit: 'Обеспечительный платёж',
}

export const brandPPData: IComparePPData = {
  type: 'standard',
  action: {
    fn: () => scrollToId(openPickPointLink.path),
    title: 'Гайд для стандартных условий',
  },
  conditions: [
    { labelKey: 'location', text: ['В любых городах, деревнях и\u00A0сёлах'], id: 0 },
    {
      labelKey: 'placement',
      text: ['В районах, где живёт много людей: рядом с домами, магазинами, школами'],
      id: 1,
    },
    {
      labelKey: 'area',
      text: ['Подойдёт площадь от 30 м²'],
      id: 2,
    },
    { labelKey: 'renovation', text: ['Нужен — требования есть ', [docs.brandbook, 'в гайде']], id: 3 },
    {
      labelKey: 'branding',
      text: ['Бренд-стена, постер и тейбл-тент внутри. Вывеска или панель-кронштейн снаружи — пришлём бесплатно'],
      id: 4,
    },
    { labelKey: 'deposit', text: ['50 000 ₽\nВернутся на баланс, если откроете ПВЗ за 30 дней'], id: 5 },
  ],
  preview: brandPreview,
}

export const villagePPData: IComparePPData = {
  type: 'simplified',
  action: { fn: () => scrollToId(openPickPointLink.path), title: 'Гайд для упрощенных условий' },
  conditions: [
    { labelKey: 'location', text: ['В населённых пунктах, где живёт до 5 000 человек'], id: 6 },
    {
      labelKey: 'placement',
      text: ['Любое, кроме частных домов. Подойдёт даже  продуктовый магазин'],
      id: 7,
    },
    {
      labelKey: 'area',
      text: ['Выделите под ПВЗ не меньше 10 м², чтобы было место для стола выдачи и хранения товаров'],
      id: 8,
    },
    {
      labelKey: 'renovation',
      text: ['Не нужен'],
      id: 9,
    },
    {
      labelKey: 'branding',
      text: ['Постер и тейбл-тент внутри. Панель-кронштейн снаружи — пришлём бесплатно'],
      id: 10,
    },
    { labelKey: 'deposit', text: ['10 000 ₽\nВернутся на баланс, если откроете ПВЗ за 30 дней'], id: 11 },
  ],
  preview: villagePreview,
}
